import { Component, HostListener, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Router } from 'express';
import { AccountService } from './core/services/account.service';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {

  title = 'Cinemateca';

  statusSearch = false;

  constructor(private metaService: Meta, private activatedRoute: ActivatedRoute, private accountService: AccountService) { }

  ngOnInit() {
    this.checkParamsForTag();
  }

  //para ver si tenemos tag de la agencia POLENTA
  checkParamsForTag() {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['utm_source']) {
        const fullUrl = window.location.href;
        const splitUrl = "utm_source" + fullUrl.split('utm_source')[1];
        if (!this.accountService.polentaUrlExists()) {
          this.accountService.polentaUrl = splitUrl;
        }
      }
    });
  }

}
